<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.062"
    height="18.442"
    viewBox="0 0 22.062 18.442"
  >
    <g transform="translate(-264.469 -427.779)">
      <path
        d="M267.816,446.221l-.968-.017-2.379-9.925h6.081Zm-2.079-8.942,1.63,6.8,1.871-6.8Z"
        fill="#777"
      />
      <path
        d="M275.854,446.183l-.983-.012-2.329-13.789h5.988Zm-2.129-12.8,1.672,9.9,1.92-9.9Z"
        fill="#777"
      />
      <path
        d="M283.889,446.159l-.991-.009-2.3-18.371h5.934Zm-2.16-17.38,1.7,13.558,1.949-13.558Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
